export const CARD_WIDTH = 516;
export const CARD_WIDTH_MOBILE = 400;
export const CARD_MARGIN = 24;
export const CARD_MARGIN_MOBILE = 16;
